module.exports = __webpack_public_path__ + "img/coupon_bg_03.e95d799e.jpg";